document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const isOpen = menu.hasAttribute('open');
      menu.toggleAttribute('open');
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const consent = form.querySelector('[data-digital-consent]');
    const button = form.querySelector('[data-add-button]');
    if (!consent || !button) return;
    const sync = () => { button.disabled = !consent.checked || button.dataset.available === 'false'; };
    consent.addEventListener('change', sync);
    sync();
  });
});
